import React from 'react';
import { Checkbox, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { CloseIcon } from '../../../UI/icons';

export const LayerCheckbox = withStyles(theme => ({
    root: {
        padding: '0',
        width: '20px',
        height: '20px',
        color: theme.palette.text.primary,
        '& .MuiIconButton-label': {
            '& .MuiSvgIcon-root' :{
                height: '20px',
                width: '20px'
            }
        },
        '&$checked': {
            color: `${theme.palette.success.main} !important`
        }
    },
    checked: {}
}))(Checkbox);

export const BigLayerCheckbox = withStyles(theme => ({
    root: {
        padding: '0',
        width: '30px',
        height: '30px',
        color: theme.palette.text.primary,
        '& .MuiIconButton-label': {
            '& .MuiSvgIcon-root' :{
                height: '30px',
                width: '30px'
            }
        },
        '&$checked': {
            color: `${theme.palette.primary.main} !important`
        }
    },
    checked: {}
}))(Checkbox);